import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import treadmillImage from 'assets/images/widget/bases/Product_SUPERMAN_94_50x50.png';
import uprightBike from 'assets/images/widget/bases/Product_SUPERMAN_90_50x50.png';
import recumbentBike from 'assets/images/widget/bases/Product_SUPERMAN_91_50x50.png';
import crossTrainer from 'assets/images/widget/bases/Product_SUPERMAN_89_50x50.png';
import powermill from 'assets/images/widget/bases/Product_SUPERMAN_95_50x50.png';
import arcTrainer from 'assets/images/widget/bases/Product_SUPERMAN_136_50x50.png';
import gscTrainer from 'assets/images/widget/bases/Product_SUPERMAN_93_50x50.png';
import flexStrider from 'assets/images/widget/bases/Product_SUPERMAN_92_50x50.png';

const useIcontyles = makeStyles({
    iconImage: {
        height: '3em',
        margin: "0.5em"
    },
    marginLeft: {
        marginLeft: "1.5em !important"
    }
});

export default function AssetIcon(props) {
    const { assetType, marginLeft, ...rest } = props;
    const classes = useIcontyles();


    function getImage(assetType) {
        switch (assetType) {
            case "treadmills": return treadmillImage
            case "uprightBikes": return uprightBike
            case "recumbentBikes": return recumbentBike
            case "crossTrainers": return crossTrainer
            case "Consumer Lifecycle": return treadmillImage
            case "Smart Lifecycle": return treadmillImage
            case "Integrity Summit Trainer": return treadmillImage
            case "Integrity Stepper": return treadmillImage
            case "flexstriders": return flexStrider
            case "powermills": return powermill
            case "Rower": return treadmillImage
            case "gscTrainers": return gscTrainer
            case "arcTrainers": return arcTrainer
            case "ICG Group Bikes": return treadmillImage
            default: return treadmillImage;
        }
    }

    function getClass() {
        if (marginLeft)
            return classes.marginLeft;
        return null;
    }

    return (
        <div {...rest}>
            <img alt={assetType} src={getImage(assetType)} className={classes.iconImage + " " + getClass()} />
        </div>
    );
}

AssetIcon.propTypes = {
    assetType: PropTypes.oneOf(["treadmills", "uprightBikes", "recumbentBikes", "crossTrainers", "flexstriders", "powermills", "gscTrainers", "arcTrainers"]),
    marginLeft: PropTypes.bool,
};

AssetIcon.defaultProps = {
    marginLeft: false
}